import React, { forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalHeader } from '../ModalHeader.js';
import { Button } from '../Button/index.js';
import { i18n } from '../../i18n/translate.js';
import everfiLogo from '../../images/everfi_logo.svg.js';
var HelpModalBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var cookieEnabled = _ref.cookieEnabled,
      copySuccess = _ref.copySuccess,
      copyToClipboard = _ref.copyToClipboard,
      currentUrl = _ref.currentUrl,
      getOS = _ref.getOS,
      getUserTypes = _ref.getUserTypes,
      helpMessage = _ref.helpMessage,
      helpMessageEnabled = _ref.helpMessageEnabled,
      isFoundry = _ref.isFoundry,
      showHelpModal = _ref.showHelpModal,
      toggleHelpModal = _ref.toggleHelpModal,
      userData = _ref.userData;
  return /*#__PURE__*/React.createElement(Modal, {
    animation: false
    /* @ts-ignore */
    ,
    container: ref,
    "aria-labelledby": "help-modal-title",
    className: "help-modal modal-size-medium",
    dialogClassName: "foundry",
    id: "help-modal",
    show: showHelpModal
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    canClickOff: true,
    closeButton: true,
    onCancel: toggleHelpModal,
    title: i18n.t('Need Help?'),
    titleId: "help-modal-title"
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("h5", null, i18n.t('System Requirements')), /*#__PURE__*/React.createElement("p", null, i18n.t('For best performance, use our'), ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://everfi.com/minimum-system-requirements",
    target: "_blank",
    className: "f-700 branded-link",
    rel: "noopener noreferrer"
  }, i18n.t('minimum system requirements')), "."), /*#__PURE__*/React.createElement("h5", null, i18n.t('Technical Support')), !!helpMessage && helpMessageEnabled
  /* Custom Support Info */
  && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: helpMessage
    }
  }), !helpMessageEnabled && isFoundry
  /* Foundry Default Support Info */
  && /*#__PURE__*/React.createElement("p", null, i18n.t('You can get help by accessing our'), ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://support.everfi.com",
    target: "_blank",
    className: "f-700 branded-link",
    rel: "noopener noreferrer"
  }, i18n.t('technical support site')), ' ', i18n.t('to read FAQs or chat with our support team.')), !helpMessageEnabled && !isFoundry
  /* Next Default Support Info */
  && /*#__PURE__*/React.createElement("p", null, i18n.t('For technical support with EVERFI course content, please email:'), ' ', /*#__PURE__*/React.createElement("a", {
    href: "mailto:learnersupport@everfi.com",
    className: "f-700 branded-link"
  }, i18n.t('learnersupport@everfi.com')), ' '), /*#__PURE__*/React.createElement("p", null, i18n.t('Please copy and paste the information below into your support message:')), /*#__PURE__*/React.createElement("section", {
    id: "help-modal-info"
  }, /*#__PURE__*/React.createElement("div", null, i18n.t('Platform'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-500",
    "data-info-value": "platform"
  }, i18n.t('Foundry')), ' '), !!userData && /*#__PURE__*/React.createElement(React.Fragment, null, !!userData.organization_name && isFoundry && /*#__PURE__*/React.createElement("div", null, i18n.t('Organization name'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-700",
    "data-info-value": "organization_name"
  }, userData.organization_name), ' '), !!userData.organization_id && isFoundry && /*#__PURE__*/React.createElement("div", null, i18n.t('Organization ID'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-700",
    "data-info-value": "organization_id"
  }, userData.organization_id), ' '), /*#__PURE__*/React.createElement("div", null, i18n.t('Operating system'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-700",
    "data-info-value": "operating_system"
  }, getOS(), ". ", i18n.t('Cookies are {{cookieEnabled}}', {
    cookieEnabled: cookieEnabled
  }), ".", ' ', i18n.t('Javascript is enabled'), ".", ' ')), /*#__PURE__*/React.createElement("br", null), (!!userData.first_name || !!userData.last_name) && /*#__PURE__*/React.createElement("div", null, i18n.t('Name'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-700",
    "data-info-value": "user_name"
  }, "".concat(userData.first_name, " ").concat(userData.last_name)), ' '), !!getUserTypes(userData) && /*#__PURE__*/React.createElement("div", null, i18n.t('User Type'), ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "f-700",
    "data-info-value": "user_type"
  }, getUserTypes(userData)), ' ')), /*#__PURE__*/React.createElement("div", null, i18n.t('Current URL'), ":", ' ', /*#__PURE__*/React.createElement("a", {
    href: currentUrl,
    className: "f-700 branded-link"
  }, currentUrl))), /*#__PURE__*/React.createElement(Button, {
    disabled: copySuccess,
    onClick: function onClick() {
      return copyToClipboard();
    },
    "data-action": "copy",
    style: "secondary",
    branded: true,
    icon: copySuccess ? 'check' : 'copy',
    label: copySuccess ? i18n.t('Copy Successful!') : i18n.t('Copy')
  }), copySuccess === false && /*#__PURE__*/React.createElement("span", {
    className: "error"
  }, " ", i18n.t('Copy unsuccessful, please copy manually')), /*#__PURE__*/React.createElement("div", {
    className: "modal-logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: everfiLogo,
    alt: i18n.t('EVERFI logo')
  }))));
});
HelpModalBody.displayName = 'HelpModalBody';
export { HelpModalBody };